import Vue from 'vue';
import VueRouter from 'vue-router';
import Ajax from '../lib/ajax'
import Utils from '../lib/utils'
import { routers } from './index';
import util from '../lib/utils';
import store from '../store/index';
import sissconst from "../lib/sissconst";
import SignalRAspNetCoreHelper from "../lib/SignalRAspNetCoreHelper";
Vue.use(VueRouter);
export const router = new VueRouter({
    base: '/mobile/',
    mode: 'history',
    routes: routers
});
router.beforeEach((to, from, next) => {
    if (from.meta.needCache) {
        if (to.meta.returnNeedCache) {
            from.meta.keepAlive = true;
        } else {
            from.meta.keepAlive = false;
        }
    }
    let app = document.querySelector('#app');
    let scrollTop = app ? app.scrollHeight : 0;
    store.commit('setscroll', scrollTop);
    let ismemberVersion = sessionStorage.getItem("ismemberVersion");
    // if(ismemberVersion == null)
    // {
    //     //show页面不判断
    //     if(to.name == "show")
    //     {
    //         next();
    //     }
    //     else
    //     {
    //         Ajax.get("/api/services/app/ShopinfoService/GetShopInfo").then(res=>{
    //             let result = res.data.result;
    //             let memberVersion = result.isMemberVersion;
    //             sessionStorage.setItem("ismemberVersion",memberVersion);
    //             if(memberVersion == "1")
    //             {
    //                 if(Utils.isMinVip(to.name))
    //                 {
    //                     next(false);
    //                 }
    //                 else
    //                 {
    //                     next();
    //                 }
    //             }
    //             else
    //             {
    //                 next();
    //             }
    //         }).catch(err=>{
    //             next(false);
    //         });
    //     }
    // }
    // else
    // {
    //     let memberVersion = ismemberVersion;
    //     if(memberVersion == "1")
    //     {
    //         if(Utils.isMinVip(to.name))
    //         {
    //             next(false);
    //         }
    //         else
    //         {
    //             next();
    //         }
    //     }
    //     else
    //     {
    //         next();
    //     }
    // }   
    //新增是否会员判断
    if (Utils.getVipPageNames().indexOf(to.name) > -1) {
        if (Utils.getUserInfo().cardId) {
            next();
        }
        else {
            Utils.toRegister(to, from, next);
        }
    }
    else {
        next();
    }
});
router.afterEach((to, from) => {
    if (to.name == 'user') {
        if (router.app.$store && (!router.app.$store.state.chatserver._chatHub || !router.app.$store.state.chatserver._chatHub.methods)) {
            //initSignalRBack();
        }
    } else if (to.name != 'chatindex' && to.name != 'chatserver') {
        if (router.app.$store && router.app.$store.state.chatserver.chatstatus && !router.app.$store.state.chatserver._chatHub) {
            router.app.$store.state.chatserver._chatHub.invoke("disconnected");
        }
    }
    if (from.name == 'chatindex') {
        router.app.$store && (router.app.$store.state.chatserver._chatIndexHub.connectionState == 1) && router.app.$store.state.chatserver._chatIndexHub.stop();
    } else if (from.name == 'chatserver') {
        router.app.$store && (router.app.$store.state.chatserver._chatServerHub.connectionState == 1) && router.app.$store.state.chatserver._chatServerHub.stop();
    }
    // setTimeout(() => {
    //     var _hmt = _hmt || [];
    //     (function () {
    //         //每次执行前，先移除上次插入的代码
    //         document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
    //         var hm = document.createElement("script");
    //         hm.src = "https://hm.baidu.com/hm.js?f34fbed0c38db17c1b8422692afcc6ee";
    //         hm.id = "baidu_tj"
    //         var s = document.getElementsByTagName("script")[0];
    //         s.parentNode.insertBefore(hm, s);
    //     })();
    // }, 0);
});
function initSignalRBack() {
    //let that=this;
    SignalRAspNetCoreHelper.initSignalRBack(() => {
        util.siss.signalr.startConnection(
            sissconst.remoteServiceBaseUrl + "/signalr-chatservernum",
            function (connection) {
                //router.app.$store.state.chatserver._chatHub = connection; // Save a reference to the hub

            }
        )
            .then(function (connection) {
                router.app.$store.commit("chatserver/setChatHub", connection);
                connection.on("getDataByvip", function (data) {
                    // Register for incoming messages
                    router.app.$store.commit("user/setChatRed", {
                        key: "chatredByvip",
                        value: 1
                    });
                });
                connection.on("getDataBysaleman", function (data) {
                    // Register for incoming messages
                    router.app.$store.commit("user/setChatRed", {
                        key: "chatredBysaleman",
                        value: 1
                    });
                });
            });
    });
}